export default __webpack_public_path__ + "static/media/dark-knight.6ebac2bc.png";